module.exports = __webpack_public_path__ + "王一鸣-158c7a89.png";